/** Only what changed between two versions of a record; removed fields become null ("unset"). */
export function diffPatch(
  before: Record<string, unknown>,
  after: Record<string, unknown>,
): Record<string, unknown> {
  const patch: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(after)) {
    if (JSON.stringify(before[key]) !== JSON.stringify(value)) patch[key] = value;
  }
  for (const key of Object.keys(before)) {
    if (!(key in after)) patch[key] = null;
  }
  return patch;
}
